/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import styled, { createGlobalStyle } from 'styled-components';
import Error from '../../components/common/ErrorMessage';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import { EcpApi } from '../../utils/api';
import { handleIliOnSubmit } from '../../utils/helpers/view/contractParameterHelper';
import { loaderDataComponent } from '../../utils/helper';

declare type EcpProps = {
  contractId: string;
};

type formType = {
  littleSensitiveTreshold: number | null;
  verySensitiveTreshold: number | null;
  id: null | number;
  contractId: null | string;
};

const IliParameter = ({ contractId }: EcpProps) => {
  // déclaration des variables
  const [paramList] = useState<any>([]);
  const [error] = useState(false);
  const [loading, setLoading] = useState(false);

  //Form fields on initialization with getParam value
  const [form, setForm] = React.useState<formType>({
    id: paramList.id,
    contractId: paramList?.contractId,
    littleSensitiveTreshold: paramList.littleSensitiveTreshold,
    verySensitiveTreshold: paramList.verySensitiveTreshold,
  });
  //fonctions de validations
  //Form fields validation
  const [validation, setValidation] = React.useState<{
    tresholds: null | any;
    tresholdMax: null | any;
  }>({
    tresholds: null,
    tresholdMax: null,
  });
  const toast = useRef<any>(null);

  const ShowToast = (severity: any, summary: any, detail: any) => {
    return toast.current?.show({
      severity: severity,
      summary: summary,
      detail: detail,
      life: 5000,
    });
  };

  const getData = async () => {
    try {
      const iliResponse = await EcpApi.getIliParameters(contractId);
      setForm((oldValues) => ({
        ...oldValues,
        id: iliResponse.data.id,
        contractId: iliResponse.data.contractId,
        littleSensitiveTreshold: iliResponse.data.littleSensitiveTreshold,
        verySensitiveTreshold: iliResponse.data.verySensitiveTreshold,
      }));
      setValidation({ tresholds: null, tresholdMax: null });
    } catch {
      console.log('Erreur lors de la récupération des données ILI');
    }
  }

  //Use effects
  useEffect(() => {
    getData();
  }, [contractId]);



  const saveIliParameters = async () => {
    setLoading(true);
    try {
      const response = await EcpApi.updateIliParameters(JSON.stringify(form));
      if (response.status === 200) {
        ShowToast(
          'success',
          'Succès',
          'Données des ILI enrégistrées'
        );
      } else {
        ShowToast(
          'error',
          'Erreur',
          "Erreur lors de l'enregistrement des données ILI"
        );
      }
    } catch (e) {
      ShowToast(
        'error',
        'Erreur',
        "Erreur lors de l'enregistrement des données ILI"
      );
    }
    setLoading(false);
  }

  return (
    <Container
      automatedTestId='ili-global-container'
      className='ili-global-container sds-reset-style'
    >
      <Styles />
      <Toast ref={toast} />
      <Container className='iliContainer'>
        <Container className='iliContent'>
          <Form
            onSubmit={saveIliParameters}
          >
            <Container
              automatedTestId='ili-body-container'
              className='bodyContent'
            >
              <Container className='midDoContent'>
                <Card className='rightTresholdContent'>
                  <Word
                    variant='p'
                    textStyle='title'
                    value='Seuils'
                    className='coef-data-title'
                  />
                  <Word
                    variant='p'
                    textStyle='normalReg'
                    value='Très sensible'
                    className='value-title'
                  />
                  <InputNumber
                    placeholder='ILI supérieur à'
                    id='ili-highSensitive'
                    value={form.verySensitiveTreshold ?? null}
                    onValueChange={(v) => {
                      const newForm = { ...form, verySensitiveTreshold: v.value ?? null };
                      setForm(newForm);
                      handleIliOnSubmit(setValidation, newForm);
                    }}
                  />
                  <Container className='formLineError'>
                    <Word
                      className='error'
                      textStyle='normalReg'
                      variant='span'
                      value={validation.tresholdMax}
                    />
                  </Container>
                  <Word
                    variant='p'
                    textStyle='normalReg'
                    value='Peu sensible'
                    className='value-title'
                  />
                  <InputNumber
                    placeholder='ILI inférieur à'
                    id='ili-littleSensitive'
                    value={form.littleSensitiveTreshold ?? null}
                    onValueChange={(v) => {
                      const newForm = { ...form, littleSensitiveTreshold: v.value ?? null };
                      setForm(newForm);
                      handleIliOnSubmit(setValidation, newForm);
                    }}
                  />
                  <Container className='formLineError'>
                    <Word
                      className='error'
                      textStyle='normalReg'
                      variant='span'
                      value={validation.tresholds}
                    />
                  </Container>
                </Card>
              </Container>
            </Container>
            <Container className='iliButton'>
              {loaderDataComponent(loading)}
              {loading === false && <StyledSectionButton>
                <Button className='ili-btn' mode='plain'>
                  <Word
                    variant='span'
                    textStyle='normalBold'
                    value='Enregistrer les modifications'
                  />
                </Button>
              </StyledSectionButton>}
            </Container>
          </Form>
        </Container>
      </Container>
      {error ? <Error IsVisible={error}></Error> : null}
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
  margin-top: 50px;
`;
const Styles = createGlobalStyle`

.ili-global-container.sds-reset-style{
  .iliContainer{  
    .error{
          color:red
        }
      .iliontent{
        width:auto !important;
      }
      .bassin-container{
        //Validation error
        .error{
          color:red
        }
        .ili-bassin-dropdown{
          .dropdown-icon-container{
            path{
              fill:#008BD2;
            }
          }
        }
    }
    // body
    .bodyContent{
      flex-direction: row;   
      justify-content: center;   
      .general-data, .check-do {
        overflow: visible;
        margin-top: 16px;
        margin-right:32px;
      }
      input.p-inputtext.p-component.p-inputnumber-input{
        background-color: #edf2fa;
        border: 1px solid #edf2fa;
        width: 249px;
        height: 55px;
        margin-top:0px;
        margin-bottom:20px;
        margin-right:20px;
        padding-left: 10px;
        font-size: 14px;
        font-style: italic;
        font-family: 'Montserrat';
        color: black;
      }
      .seuil-input{
        width: fit-content
      }
      //titre
      .general-data-title, .do-data-title, .people-data-title, .coef-data-title{
        text-align: center;
        margin-bottom: 15px;
      }
      // données générales
      //prise en compte des déversements donnees habitants
      .midDoContent{ 
        .check-do{
          .ili-switch{
            align-self: center;
            margin-bottom: 10px;
          }
        } 
        .data-citizen{
          overflow: visible;
          margin-top: 16px;
          margin-right:32px; 

          .sds-word.tinyRegular.field-label{
            font-size:14px;
            color: #232323
          }
          sds-input{
            font-family: 'Montserrat';
          }
          .citizen-consumption{
            .citizen-align{
              flex-direction: row;      
              .consumption-unit{
                line-height: 4;
                margin-left:10px;
              }
            }
          }
        }
      }
        // tresholds
        .rightTresholdContent{
          overflow: visible;
          margin-top: 16px;
          margin-right:32px; 
          .FilterSelect{
            width:80%;
            align-self:center;
            margin-bottom: 15px;
            .filter-animate-content{
              background-color: #008BD2
            }            
          }
          .sds-word.tinyRegular.field-label{
            font-size:14px;
            color: #232323
          }   
        }
      
    }
    .iliButton{
      align-items: center;
      margin-top: 15px;
    }
  }
}
`;

export default IliParameter;
